define([
    'text!./templates/mfp-quoting-page-coverage-view.html',
], (templateStr) => {

    MFPQuotingPageCoverageViewDirective.$inject = ['MFPService', 'BaslerCommonService'];
    function MFPQuotingPageCoverageViewDirective(MFPService, BaslerCommonService) {
        return {
            restrict: 'E',
            scope: {
                coverage: '=',
                selected: '=',
                readonly: '=',
            },
            template: templateStr,
            link: function ($scope) {
                $scope.coverageHasTerms = coverageHasTerms;
                $scope.selectedClass = selectedClass;
                $scope.displayCoverageTermHelpText = displayCoverageTermHelpText;
                $scope.formatCoverageTerm = MFPService.formatCoverageTerm;
                $scope.shouldDisplayCoverageTerm = MFPService.shouldDisplayCoverageTerm;
                $scope.getPromotionDescription = getPromotionDescription;

                function coverageHasTerms(coverage) {
                    return Boolean(coverage && coverage.terms && coverage.terms.length > 0);
                }

                function selectedClass() {
                    return $scope.selected ? 'mfp-quoting-page-coverage-view-selected' : '';
                }

                function displayCoverageTermHelpText(patternCode) {
                    const allowedPatternCodes = [
                        //Note: GALRE-43343 - No coverage term has an info icon
                    ];
                    return allowedPatternCodes.indexOf(patternCode) >= 0;
                }

                /**
                 * Gets the text for the given promotion description.
                 * Takes the Typecode text and replaces *amount* with the real amount value from the promotion.
                 */
                function getPromotionDescription(costElement) {
                    const typecode = BaslerCommonService.getTypecode('PromotionDescription_Ext', costElement.promotionDescription);
                    const result = typecode.name.replace('*amount*', `${costElement.cost.currency.toUpperCase()} ${Math.abs(costElement.cost.amount)}`);
                    return result;
                }
            },
        };
    }
    return MFPQuotingPageCoverageViewDirective;
});


// WEBPACK FOOTER //
// ../common/js/src/edge/quoteandbind/mfp/directives/MFPQuotingPageCoverageView.js